import { ReactElement } from 'react';
import EquipmentForm from './EquipmentForm';

interface Manufacturer {
  id: string;
  name: string;
  notes?: string;
}

interface AddEquipmentFormProps {
  equipmentType: string;
  manufacturers: Manufacturer[];
  onSuccess: () => void;
  onCancel: () => void;
}

const AddEquipmentForm = (props: AddEquipmentFormProps): ReactElement => {
  return <EquipmentForm mode="add" {...props} />;
};

export default AddEquipmentForm;
